import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import "@/App.css";

import { AuthProvider, useAuth } from "@/lib/AuthContext";
import TopBar from "@/components/TopBar";
import LoginPage from "@/pages/LoginPage";
import ForgePage from "@/pages/ForgePage";
import GovernancePage from "@/pages/GovernancePage";
import LLMConfigPage from "@/pages/LLMConfigPage";
import PromptsPage from "@/pages/PromptsPage";
import TasksPage from "@/pages/TasksPage";

function Loading() {
    return (
        <div className="min-h-screen flex items-center justify-center text-[color:var(--text-muted)] text-sm font-light">
            Loading…
        </div>
    );
}

function ProtectedShell({ adminOnly = false }) {
    const { user, loading, isAdmin } = useAuth();
    if (loading) return <Loading />;
    if (!user) return <Navigate to="/login" replace />;
    if (adminOnly && !isAdmin) return <Navigate to="/tasks" replace />;
    return (
        <div className="App grain-bg min-h-screen">
            <TopBar />
            <Outlet />
            <footer className="max-w-[1440px] mx-auto px-6 lg:px-10 py-8 mt-10 border-t border-[color:var(--border-subtle)] flex flex-col md:flex-row justify-between gap-3 text-xs text-[color:var(--text-muted)] font-light">
                <div>© {new Date().getFullYear()} Profecia Links · Dubai · Dublin · Pune</div>
                <div className="font-mono uppercase tracking-widest text-[10px]">
                    PromptForge · Higgsfield-ready prompt orchestration
                </div>
            </footer>
        </div>
    );
}

function RoleBasedLanding() {
    const { user, loading, isAdmin } = useAuth();
    if (loading) return <Loading />;
    if (!user) return <Navigate to="/login" replace />;
    // Creators land on Tasks; admins land on the Forge (they can jump to governance from nav)
    return <Navigate to={isAdmin ? "/forge" : "/tasks"} replace />;
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route element={<ProtectedShell />}>
                        <Route path="/" element={<RoleBasedLanding />} />
                        <Route path="/forge" element={<ForgePage />} />
                        <Route path="/tasks" element={<TasksPage />} />
                    </Route>
                    <Route element={<ProtectedShell adminOnly />}>
                        <Route path="/governance" element={<GovernancePage />} />
                        <Route path="/admin/llm-config" element={<LLMConfigPage />} />
                        <Route path="/admin/prompts" element={<PromptsPage />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
